module.exports = __webpack_public_path__ + "static/media/kp.69b9a975.svg";